// extracted by mini-css-extract-plugin
module.exports = {"form":"form_form__2whjT","lableForm":"form_lableForm__10dRa","inputLable":"form_inputLable__3q15G","button":"form_button__3Vmid","flex":"form_flex__xT58s"};